<template>
  <v-hover :disabled="hoverdisabled">
    >
    <v-flex xs12 d-flex slot-scope="{ hover }" :class="`elevation-${hover ? 6 : 0}`">
      <v-card
        :color="severity.color"
        flat
        tile
        width="20px"
        style="flex: 0 0 20px !important; text-align: center; color: white; vertical-align: middle;"
      >{{ severity[highlightFieldDisplayName] }}</v-card>
      <slot name="content"></slot>
      <slot :hover="hover" name="actions"></slot>
    </v-flex>
    <!--<v-flex xs2 d-flex>
        <slot :hover="hover" name="actions"></slot>
    </v-flex>-->
  </v-hover>
</template>

<script>
import { Importance } from "@/datatypes/Importance";
export default {
  props: {
    severity: {
      type: [Object, Importance],
      default() {
        return new Importance();
      }
    },
    hover: { type: Boolean, default: false },
    hoverdisabled: {
      type: Boolean,
      default: false
    },
    highlightFieldDisplayName: {
      type: String,
      default: "value"
    }
  }
};
</script>
